import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import WhoItsFor from './pages/WhoItsFor';
import Investors from './pages/Investors';
import Waitlist from './pages/Waitlist';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';
import Governance from './pages/Governance';
import Volunteer from './pages/Volunteer';
function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <div className="flex-grow">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/how-it-works' element={<Home />} />
            <Route path='/who-its-for' element={<WhoItsFor />} />
            <Route path='/investors' element={<Investors />} />
            <Route path='/waitlist' element={<Waitlist />} />
            <Route path='/volunteer-portal' element={<Volunteer />} />
            <Route path='/governance' element={<Governance />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;